import type { ZodTypeAny } from 'zod'

export function getAllKeys(obj: Record<string, any>, parentKey = ''): Record<string, string> {
  const result: Record<string, string> = {}
  Object.entries(obj).forEach(([key, value]) => {
    const nestedKey = parentKey ? `${parentKey}.${key}` : key
    if (typeof value === 'object' && value !== null) {
      return Object.assign(result, getAllKeys(value, nestedKey))
    }

    const keysArray = nestedKey.split('.')
    const lastKey = keysArray.pop()
    if (lastKey) {
      result[lastKey] = nestedKey
    }
  })
  return result
}

/**
 * Builds a { stepName: schema } lookup from a flow config's steps so a flow page
 * can resolve the active step's validation schema. Generic across flow configs —
 * reuse for other flow migrations instead of inlining the loop per page.
 */
export function getStepSchemas(steps: Record<string, unknown>): Record<string, ZodTypeAny> {
  const result: Record<string, ZodTypeAny> = {}
  for (const [name, step] of Object.entries(steps)) {
    if (step && typeof step === 'object' && 'schema' in step && step.schema) {
      result[name] = step.schema as ZodTypeAny
    }
  }
  return result
}

/**
 * Form path prefix under which a product's quote configuration parameters
 * (tariff / coverage selects) live. Used to detect which field changes should
 * trigger a price refetch. Generic across product migrations.
 */
export function getQuoteConfigPathPrefix(productKey: string): string {
  return `products.${productKey}.configuration_parameters.`
}
